import { GraduationCap, PersonStanding } from "lucide-react";
import { NavItem } from "@/components/layout/Menu/MenuGridIcon";
import { MenuRowIcon } from "@/components/layout/Menu/MenuRowIcon";
import { NavLink } from "react-router-dom";
import sla_logo from "@/assets/images/sla-2026.png";
import { Roles } from "iasma-datatypes";

export const MainMenu: React.FC = () => {
	const navItems: NavItem[] = [
		{
			label: 'Komunitas', to: '/community', icon: <PersonStanding size={32} />,
			roles: [Roles.SUPER_SUPER] 
		},
		{ label: 'Basisdata', to: '/directory', icon: <GraduationCap size={32} /> },
	];

	return <div className="flex flex-row items-center w-full md:w-auto">
		<NavLink to="/sla" className="flex flex-col items-center justify-center pl-4 mt-1 group">
			<div className="text-blue-500 group-hover:text-blue-600 group-hover:scale-110 mb-3 drop-shadow hover:drop-shadow-xl transform hover:-translate-y-1 transition-all duration-200 ">
				<img src={sla_logo} alt="" className="w-7 h-7" />
			</div>
			<span className="text-xs font-medium text-(--color-secondary) text-center">
				SLA 2026
			</span>
		</NavLink>
		<MenuRowIcon menus={navItems} root={true} />
	</div>
}
